"use client";
import { Box, Button, Typography } from "@mui/material";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import React, { useCallback, useEffect, useMemo, useState } from "react";
import { useRouter } from "next/navigation";
import { AddToCartService, Cart } from "@/app/services/cart";
import { useCurrencyCode } from "../../helper-functions/CurrencySymbol";
import { Loader } from "../../MainLoader/Loader";

export const CartButton = (cid: any) => {
  const router = useRouter();
  const addToCartService = useMemo(() => new AddToCartService(), []);
  const [cart, setCart] = useState(new Cart());
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const currencyCode = useCurrencyCode();

  const handleNaviagteToCart = (e: any) => {
    e.preventDefault();
    setLoading(true);
    router.push("/cart");
  };

  const getInitializeCart = useCallback(() => {
    const mainCart = addToCartService.getCart();
    if (!mainCart) {
      // console.log("No cart found");
      return;
    }
    const cartCidValid = mainCart?.cartItemRequestsById.find(
      (item: any) => item.cid === cid?.cid
    );

    if (cartCidValid) {
      const totalCount = cartCidValid?.cartItemRequests.reduce(
        (acc: any, item: any) => acc + item.count,
        0
      );
      setCart(cartCidValid);
      setCount(totalCount);
    } else {
      // console.log(`No cart found for CID`);
      setCart(new Cart());
      setCount(0);
    }
  }, [addToCartService, cid]);

  useEffect(() => {
    const intr = setInterval(() => {
      getInitializeCart();
    }, 1000);
    return () => {
      clearInterval(intr);
    };
  }, [getInitializeCart]);

  return (
    <Box
      sx={{
        background: "#fff",
        position: "fixed",
        bottom: -1,
        zIndex: 1000,
        width: "100%",
      }}
    >
      <Button
        variant="contained"
        color="success"
        onClick={handleNaviagteToCart}
        disabled={
          cart?.cartItemRequests?.length === 0 ||
          cart == null ||
          undefined ||
          Object.keys(cart).length === 0
            ? true
            : false
        }
        sx={{
          margin: "0.5rem",
          width: "-webkit-fill-available",
          borderRadius: "10rem",
          display: { xs: "flex", sm: "none" },
          justifyContent: "space-between",
          alignItems: "center",
          padding: "4px 16px",
        }}
      >
        {loading && <Loader />}
        <Box
          sx={{
            display: "flex",
            justifyContent: "left",
            alignItems: "center",
          }}
        >
          <Typography
            variant="body1"
            sx={{
              color: "#15741a",
              background: "white",
              borderRadius: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "27px",
              height: "27px",
              fontWeight: "bold",
              marginRight: "1rem",
              cursor: "pointer",
            }}
          >
            {count ? count : 0}
          </Typography>
          <Box
            sx={{
              justifyContent: "left",
              display: "grid",
              alignItems: "center",
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontWeight: "bold",
                textAlign: "left",
              }}
            >
              {currencyCode}
              {cart?.totalAmount ? cart?.totalAmount : 0}
            </Typography>
            <Box
              sx={{
                display: "flex",
                justifyContent: "left",
                alignItems: "center",
              }}
            >
              <Typography
                variant="body2"
                sx={{
                  fontWeight: "bold",
                  textDecoration: "line-through",
                }}
              >
                {currencyCode}
                {cart?.totalMrp ? cart?.totalMrp : 0}
              </Typography>
              &nbsp; &nbsp;
              <Typography
                variant="body1"
                sx={{
                  fontWeight: "bold",
                  textTransform: "capitalize",
                }}
              >
                Save {currencyCode}
                {cart?.totalDiscount ? cart?.totalDiscount : 0}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box>
          <Typography
            variant="body1"
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "bold",
            }}
          >
            Continue <KeyboardArrowRightIcon />
          </Typography>
        </Box>
      </Button>
    </Box>
  );
};
